const _excluded = ["children", "className", "onActiveTabChange", "style", "theme"];
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import classNames from 'classnames';
import { Children, forwardRef, useEffect, useId, useImperativeHandle, useMemo, useRef, useState } from 'react';
import { useTheme } from '../../';
import { mergeDeep } from '../../helpers/merge-deep';
import { TabItem } from './TabItem';
export const TabsComponent = /*#__PURE__*/forwardRef((_ref, ref) => {
  let children = _ref.children,
    className = _ref.className,
    onActiveTabChange = _ref.onActiveTabChange,
    _ref$style = _ref.style,
    style = _ref$style === void 0 ? 'default' : _ref$style,
    _ref$theme = _ref.theme,
    customTheme = _ref$theme === void 0 ? {} : _ref$theme,
    props = _objectWithoutProperties(_ref, _excluded);
  const theme = mergeDeep(useTheme().theme.tab, customTheme);
  const id = useId();
  const tabs = useMemo(() => Children.map(children, _ref2 => {
    let props = _ref2.props;
    return props;
  }), [children]);
  const tabRefs = useRef([]);
  const _useState = useState(Math.max(0, tabs.findIndex(tab => tab.active))),
    _useState2 = _slicedToArray(_useState, 2),
    activeTab = _useState2[0],
    setActiveTab = _useState2[1];
  const _useState3 = useState(-1),
    _useState4 = _slicedToArray(_useState3, 2),
    focusedTab = _useState4[0],
    setFocusedTab = _useState4[1];
  const setActiveTabWithCallback = activeTab => {
    setActiveTab(activeTab);
    if (onActiveTabChange) onActiveTabChange(activeTab);
  };
  const handleClick = _ref3 => {
    let target = _ref3.target;
    setActiveTabWithCallback(target);
    setFocusedTab(target);
  };
  const handleKeyboard = _ref4 => {
    let event = _ref4.event,
      target = _ref4.target;
    if (event.key === 'ArrowLeft') {
      setFocusedTab(Math.max(0, focusedTab - 1));
    }
    if (event.key === 'ArrowRight') {
      setFocusedTab(Math.min(tabs.length - 1, focusedTab + 1));
    }
    if (event.key === 'Enter') {
      setActiveTabWithCallback(target);
      setFocusedTab(target);
    }
  };
  const tabItemStyle = theme.tablist.tabitem.styles[style];
  useEffect(() => {
    var _tabRefs$current$focu;
    (_tabRefs$current$focu = tabRefs.current[focusedTab]) === null || _tabRefs$current$focu === void 0 ? void 0 : _tabRefs$current$focu.focus();
  }, [focusedTab]);
  useImperativeHandle(ref, () => ({
    setActiveTab: setActiveTabWithCallback
  }));
  return _jsxs("div", {
    className: classNames(theme.base, className),
    children: [_jsx("div", _objectSpread(_objectSpread({
      "aria-label": "Tabs",
      role: "tablist",
      className: classNames(theme.tablist.base, theme.tablist.styles[style], className)
    }, props), {}, {
      children: tabs.map((tab, index) => _jsxs("button", {
        type: "button",
        "aria-controls": `${id}-tabpanel-${index}`,
        "aria-selected": index === activeTab,
        className: classNames(theme.tablist.tabitem.base, _objectSpread({}, tabItemStyle), {
          [tabItemStyle.active.on]: index === activeTab,
          [tabItemStyle.active.off]: index !== activeTab && !tab.disabled
        }),
        disabled: tab.disabled,
        id: `${id}-tab-${index}`,
        onClick: () => handleClick({
          target: index
        }),
        onKeyDown: event => handleKeyboard({
          event,
          target: index
        }),
        ref: element => tabRefs.current[index] = element,
        role: "tab",
        tabIndex: index === focusedTab ? 0 : -1,
        children: [tab.icon && _jsx(tab.icon, {
          className: theme.tablist.tabitem.icon
        }), tab.title]
      }, index))
    })), _jsx("div", {
      children: tabs.map((tab, index) => _jsx("div", {
        "aria-labelledby": `${id}-tab-${index}`,
        className: theme.tabpanel,
        hidden: index !== activeTab,
        id: `${id}-tabpanel-${index}`,
        role: "tabpanel",
        tabIndex: 0,
        children: tab.children
      }, index))
    })]
  });
});
TabsComponent.displayName = 'Tabs.Group';
export const Tabs = {
  Group: TabsComponent,
  Item: TabItem
};